export default __webpack_public_path__ + "static/media/job-opportunity_icon.311b8190.png";